import { createContext, type ReactNode, useContext } from 'react'

import {
  type AppointmentFields,
  type Carrier,
  type OpenDockWarehouseDetails,
  type ScheduleFormValues,
} from '../../domain/Shipment'
import { type Step } from './steps'

export type OpenDockDrawerValue = {
  shipmentUUID: string
  stopIndex: number
  facilityTimezone?: string
  shipmentCarrier: Carrier
  warehouseDetails: OpenDockWarehouseDetails
  carrierId: string | undefined
  fields: AppointmentFields
  setStep: (step: Step) => void
  setStaticFields: (staticFields: Partial<ScheduleFormValues>) => void
  onConfirm: () => void
  onClose: () => void
}

const OpenDockDrawerContext = createContext<OpenDockDrawerValue | null>(null)

export function OpenDockDrawerProvider({
  value,
  children,
}: {
  value: OpenDockDrawerValue
  children: ReactNode
}) {
  return <OpenDockDrawerContext.Provider value={value}>{children}</OpenDockDrawerContext.Provider>
}

export function useOpenDockDrawer() {
  const context = useContext(OpenDockDrawerContext)

  if (context === null) {
    throw new Error('useOpenDockDrawer must be used within an OpenDockDrawerProvider')
  }

  return context
}
